import React from "react"

import Savings from "assets/illustrations/savings.svg"

import Received from "assets/icons/received.svg"
import Megaphone from "assets/icons/megaphone.svg"
import Deposit from "assets/icons/deposit.svg"

import styles from "./financialWellbeign.module.css"

const FinancialWellbeign = () => {
  return (
    <section className={styles.financialWellbeign}>
      <div className="wrapper">
        <h2>O Bem-estar financeiro</h2>
        <div className={styles.feature}>
          <div>
            <Savings className={styles.illustration} />
          </div>
          <div className={styles.content}>
            <p>
              Quando estamos doentes, mesmo com uma gripe comum, e tentamos
              trabalhar, nosso desempenho é diretamente afetado. A preocupação
              com falta de dinheiro, estresse e até questões psicológicas
              agravadas pelo comprometimento da renda também influenciam
              negativamente na nossa produtividade.
            </p>
            <p>
              Investir em bem-estar financeiro é simples. As ações mais efetivas
              para que funcionários consigam alcançar são:
            </p>
            <ul className={styles.actions}>
              <li>
                <Received className={styles.icon} /> Acesso a crédito justo
              </li>
              <li>
                <Megaphone className={styles.icon} />
                Treinamentos e workshops
              </li>
              <li>
                <Deposit className={styles.icon} />
                Ajudar a poupar
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  )
}

export default FinancialWellbeign
